import {
  GET_CATEGORY,
  INSERT_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  FULFILLED,
  REJECTED,
  PENDING
} from "../utils/types";
const initialState = {
  data: {},
  getError: false,
  updateError: false,
  deleteError: false,
  insertError: false,
  getLoading: false,
  updateLoading: false,
  deleteLoading: false,
  insertLoading: false
};

export default function categoryReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    // GET
    case `${GET_CATEGORY + PENDING}`:
      return { ...state, getError: false, getLoading: true };
    case `${GET_CATEGORY + FULFILLED}`:
      return { ...state, data: payload, getError: false, getLoading: false };
    case `${GET_CATEGORY + REJECTED}`:
      return { ...state, getError: true, getLoading: false, data: {} };
    // UPDATE
    case `${UPDATE_CATEGORY + PENDING}`:
      return { ...state, updateError: false, updateLoading: true };
    case `${UPDATE_CATEGORY + FULFILLED}`:
      return {
        ...state,
        data: payload,
        updateError: false,
        updateLoading: false
      };
    case `${UPDATE_CATEGORY + REJECTED}`:
      return { ...state, updateError: true, updateLoading: false };
    // DELETE
    case `${DELETE_CATEGORY + PENDING}`:
      return { ...state, deleteError: false, deleteLoading: true };
    case `${DELETE_CATEGORY + FULFILLED}`:
      return {
        ...state,
        data: payload,
        deleteError: false,
        deleteLoading: false
      };
    case `${DELETE_CATEGORY + REJECTED}`:
      return { ...state, deleteError: true, deleteLoading: false};
    // INSERT
    case `${INSERT_CATEGORY + PENDING}`:
      return { ...state, insertError: false, insertLoading: true };
    case `${INSERT_CATEGORY + FULFILLED}`:
      return {
        ...state,
        data: payload,
        insertError: false,
        insertLoading: false
      };
    case `${INSERT_CATEGORY + REJECTED}`:
      return { ...state, insertError: true, insertLoading: false};
    default:
      return state;
  }
}
